import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export function PostNotFound() {
    const modalTitle = <Typography>Beitrag nicht verfügbar</Typography>;
    const modalContent = (
        <ContentTypography>
            Hoppla! Dieser Beitrag hat wohl einen Abstecher gemacht.
            Wahrscheinlich wurde er vom Ersteller gelöscht.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
